module.exports = __webpack_public_path__ + "static/Thailand-903348aa61af196c129cdca2934a512e.jpg";